<template>
  <div class="fill-height">
    <v-snackbar
      v-model="dialog.snackbar"
      top
      right
      color="#B71C1C">
      <span class="body-1 font-weight-light white--text"
        v-html="message.success">
      </span>

      <template v-slot:action="{ attrs }">
        <v-btn
          class="body-1 font-weight-bold text-capitalize"
          color="white"
          icon
          v-bind="attrs"
          @click="dialog.snackbar = false">
          <v-icon>mdi-close-circle-outline</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

    <v-dialog v-model="dialog.form"
      @keydown.esc="dialog.form = false"
      :fullscreen="dialog.fullscreen"
      width="900"
      persistent
      scrollable>
      <v-card 
        class="border-radius pa-2">
        <v-card-title 
          class="d-flex align-center py-0 px-3 text-right popup-header">
          <v-avatar 
            size="30">
            <v-img
              alt="vuetify"
              :src="require('@/assets/logo/favicon.png')">
              <template v-slot:placeholder>
                <v-row
                  class="fill-height"
                  align="center"
                  justify="center">
                  <v-progress-circular 
                    indeterminate 
                    color="#B71C1C">
                  </v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-avatar>

          <span class="mt-1 ml-1">
            {{ form.id === '' ? 'Tambah' : 'Ubah' }}
          </span>

          <v-spacer/>

          <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            color="#B71C1C">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.form = false"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon>
        </v-card-title>

        <v-divider class="mx-4 mt-3 mb-2"/>

        <v-card-text 
          class="pt-2 body-1 line-text-second">
          <ValidationObserver ref="form">
            <v-form class="text-left">
              <v-row>
                <v-col
                  cols="12"
                  md="3">
                  <uploadfolder v-model="upload.folder"
                    style="position: sticky; top: 0;">
                    <div slot="activator" class="cursor-pointer">
                      <v-card 
                        flat
                        :height="!dialog.fullscreen ? 200 : 350"
                        class="d-flex align-center justify-center"
                        style="border-radius: 15px;
                              border: 2px solid #eaeaea; 
                              border-style: dashed;">
                        <v-img v-if="!process.image && form.image !== ''"
                          alt="kominfo" 
                          width="100%"
                          :height="!dialog.fullscreen ? 195 : 345"
                          gradient="to bottom, rgba(0, 0, 0, .1), rgba(0, 0, 0, .5)"
                          :src="form.image"
                          class="ma-auto d-flex align-center text-center">
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height"
                              align="center"
                              justify="center">
                              <v-progress-circular 
                                indeterminate 
                                color="#B71C1C">
                              </v-progress-circular>
                            </v-row>
                          </template>

                          <v-icon 
                            size="65" 
                            color="white">
                            mdi-cloud-upload-outline
                          </v-icon>
                        </v-img>

                        <v-icon v-if="!process.image && form.image === ''"
                          size="65" 
                          color="grey">
                          mdi-cloud-upload-outline
                        </v-icon>

                        <v-progress-circular v-if="process.image"
                          indeterminate
                          color="#B71C1C">
                        </v-progress-circular>
                      </v-card>
                    </div>
                  </uploadfolder>
                </v-col>

                <v-col
                  cols="12"
                  md="9">
                  <ValidationProvider 
                    name="tipe_darah" 
                    rules="required" 
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>
                      Tipe Darah
                      <span class="error--text">
                        (wajib diisi)
                      </span>
                    </div>

                    <v-select
                      style="width: 25%;"
                      dense
                      outlined
                      single-line
                      hide-details
                      color="#B71C1C"
                      item-color="red darken-1"
                      placeholder="Contoh: A+"
                      :items="['A', 'A-', 'A+', 'B', 'B-', 'B+', 'AB', 'AB-', 'AB+', 'O', 'O-', 'O+']"
                      v-model="form.tipe_darah"
                      :success="form.tipe_darah !== ''">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            Tipe Darah {{ errors[0] }}
                          </v-tooltip>
                        </div>

                        <div v-if="form.tipe_darah !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-select>
                  </ValidationProvider>

                  <div
                    class="my-6">
                    <ValidationProvider 
                      name="produk" 
                      rules="required" 
                      v-slot="{ errors, valid }">
                      <div class="body-2 mb-2">
                        <span class="red--text">*</span>
                        Produk
                        <span class="error--text">
                          (wajib diisi)
                        </span>
                      </div>
                      
                      <v-text-field
                        v-on:keyup.enter="save"
                        style="max-width: 35%;"
                        dense
                        outlined
                        color="#B71C1C"
                        hide-details
                        placeholder="Contoh. TC"
                        
                        v-model="form.produk"
                        vvvv-uppercase
                        :success="form.produk !== '' && valid"
                        :error-messages="errors"
                        required>
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              Produk {{ errors[0] }}
                            </v-tooltip>
                          </div>

                          <div v-if="form.produk !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>
                  </div>

                  <div
                    class="my-6">
                    <ValidationProvider 
                      name="stok" 
                      rules="required|min:0"
                      v-slot="{ errors, valid }">
                      <div class="body-2 mb-2">
                        <span class="red--text">*</span>
                        Stok
                        <span class="error--text">
                          (wajib diisi)
                        </span>
                      </div>
                      
                      <v-text-field
                        v-on:keyup.enter="save"
                        style="max-width: 30%;"
                        type="number"
                        onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                        min="0"
                        dense
                        outlined
                        color="#B71C1C"
                        hide-details
                        placeholder="Contoh. 20"
                        
                        v-model="form.stok"
                        vvvv-uppercase
                        :success="form.stok !== '' && valid"
                        :error-messages="errors"
                        required>
                        <template v-slot:append-outer>
                          <div v-if="errors.length > 0">
                            <v-tooltip top color="#ff5252">
                              <template v-slot:activator="{ on }">
                                <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                              </template>
                              
                              Stok {{ errors[0] }}
                            </v-tooltip>
                          </div>

                          <div v-if="form.stok !== '' && valid">
                            <v-icon color="success">mdi-check-circle-outline</v-icon>
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>
                  </div>

                  <div class="my-6">
                    <div class="body-2 mb-2">
                      Keterangan (boleh dikosongi)
                    </div>

                    <quill-editor 
                      ref="myTextEditor"
                      :options="{
                        placeholder: 'Contoh. Silahkan isi deskripsi / konten . . .'
                      }"
                      v-model="form.content">
                    </quill-editor>
                  </div>

                  <div
                    class="my-6">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>
                      Alamat Lengkap
                      <span class="error--text">
                        (wajib diisi)
                      </span>
                    </div>
                    
                    <v-row>
                      <v-col 
                        cols="10" 
                        class="py-0 pr-0">
                        <div 
                          class="v-input v-input--dense theme--light v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined">
                          <div 
                            class="v-input__control">
                            <div 
                              class="v-input__slot">
                              <!-- <div 
                                class="v-input__prepend-inner">
                                <div 
                                  class="v-input__icon v-input__icon--prepend-inner">
                                  <i 
                                    aria-hidden="true" 
                                    class="v-icon notranslate mdi mdi-home-map-marker theme--light">
                                  </i>
                                </div>
                              </div> -->

                              <fieldset 
                                aria-hidden="true">
                                <legend 
                                  style="width: 0px;">
                                  <span>​</span>
                                </legend>
                              </fieldset>

                              <div 
                                class="v-text-field__slot">
                                <label 
                                  for="input-147" 
                                  class="v-label theme--light"
                                   style="left: 0px; right: auto; position: absolute;">
                                  <!-- Alamat -->
                                </label>

                                <gmap-autocomplete 
                                  placeholder="Contoh. Jl. Pemuda No. 07" 
                                  :value="form.address" 
                                  :select-first-on-enter="true"
                                  @place_changed="setPlace">
                                </gmap-autocomplete>
                              </div>
                            </div>

                            <!-- <div 
                              class="v-text-field__details">
                              <div 
                                class="v-messages theme--light">
                                <div class="v-messages__wrapper">
                                </div>
                              </div>
                            </div> -->
                          </div>
                        </div>
                      </v-col>

                      <v-col 
                        cols="2" 
                        class="py-0"
                        :style="$vuetify.breakpoint.name === 'xs' ? 'position:relative; left: -30px;' : 'position:relative; left: -40px;'">
                        <v-btn
                          @click="dialog.map = true; dialog.form = false;"
                          color="#5d5d5d"
                          height="40"
                          elevation="0"
                          style="border-radius: 0px 4px 4px 0px;"
                          class="body-2 font-weight-bold text-capitalize white--text">
                          <span v-if="$vuetify.breakpoint.name !== 'xs'">
                            Pilih Dari Peta
                          </span>

                          <v-icon v-if="$vuetify.breakpoint.name === 'xs'">
                            mdi-google-maps
                          </v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </div>

                  <ValidationProvider 
                    name="status" 
                    rules="required" 
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>
                      Status
                      <span class="error--text">
                        (wajib diisi)
                      </span>
                    </div>

                    <v-select
                      style="width: 35%;"
                      dense
                      outlined
                      single-line
                      hide-details
                      color="#B71C1C"
                      item-color="red darken-1"
                      placeholder="Contoh: Publish"
                      :items="[
                        {
                          text: 'Publish',
                          value: 'publish'
                        },
                        {
                          text: 'Draft',
                          value: 'draft'
                        }
                      ]"
                      v-model="form.status"
                      :success="form.status !== ''">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            Status {{ errors[0] }}
                          </v-tooltip>
                        </div>

                        <div v-if="form.status !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-select>
                  </ValidationProvider>
                </v-col>
              </v-row>
            </v-form>
          </ValidationObserver>
        </v-card-text>

        <v-divider class="mx-4 mb-3 mt-0"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            color="#B71C1C"
            elevation="0"
            class="body-2 font-weight-bold text-capitalize white--text"
            :disabled="process.form"
            :loading="process.form"
            v-on:keyup.enter="save()"
            @click="save()">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>
            Simpan
          </v-btn>

          <v-btn
            outlined
            class="body-2 font-weight-bold text-capitalize red--text"
            :disabled="process.form"
            @click="dialog.form = false">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Batal
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog  v-model="dialog.map" 
      @keydown.esc="dialog.map = false"
      :fullscreen="dialog.fullscreen"
      width="600"
      persistent
      scrollable>
      <v-card
        class="border-radius pa-2">
        <v-card-text
          class="px-0">
          <gmap-map
            class="_maps"
            :center="center"
            :zoom="15"
            :clickable="true"
            @click="updatePlace"
            :options="{
              zoomControl: true,
              mapTypeControl: false,
              scaleControl: false,
              streetViewControl: false,
              rotateControl: false,
              fullscreenControl: true,
              disableDefaultUi: false
            }">

            <gmap-marker
              :position="center"
              :draggable="true"
              @drag="updatePlace"
              @click="center = center">
            </gmap-marker>
          </gmap-map>
        </v-card-text>
        
        <v-divider class="mx-4 mb-3 mt-0"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            @click="dialog.map = false; dialog.form = true;"
            color="#B71C1C"
            elevation="0"
            class="body-2 font-weight-bold text-capitalize white--text">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>
            Terapkan
          </v-btn>

          <v-btn 
            @click="
              dialog.map = false; 
              dialog.form = true;
              form.address = ''; 
              form.extra.lat = '';
              form.extra.lng = '';"
            outlined
            class="body-2 font-weight-bold text-capitalize red--text">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Batalkan
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.delete"
      @keydown.esc="dialog.delete = false"
      :fullscreen="dialog.fullscreen"
      width="450"
      persistent
      scrollable>
      <v-card 
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'"
        class="pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
          <v-avatar size="30">
            <v-img
              alt="vuetify"
              :src="require('@/assets/logo/favicon.png')">
              <template v-slot:placeholder>
                <v-row
                  class="fill-height"
                  align="center"
                  justify="center">
                  <v-progress-circular 
                    indeterminate 
                    color="#B71C1C">
                  </v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-avatar>

          <span class="mt-1 ml-2">
            Hapus Data
          </span>

          <v-spacer/>

          <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            color="#B71C1C">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon>
        </v-card-title>
        
        <v-divider class="mx-4 mt-3 mb-2"/>

        <v-card-text class="body-1 font-weight-light text-first mt-3">
          Apakah Anda yakin menghapus data Golongan Darah yang Anda pilih?
        </v-card-text>

        <v-alert v-if="message.error.length > 0"
          class="mx-6"
          type="error" 
          dense
          text 
          prominent>
          {{ message.error }}
        </v-alert>

        <v-divider class="mx-4 mb-3 mt-0"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            color="#B71C1C"
            elevation="0"
            class="body-2 font-weight-bold text-capitalize white--text"
            :disabled="process.delete"
            :loading="process.delete"
            @click="deletes()">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>
            Ya, Hapus
          </v-btn>

          <v-btn
            outlined
            class="body-2 font-weight-bold text-capitalize red--text"
            :disabled="process.delete"
            @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Batal
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-layout wrap>
      <v-flex>
        <section>
          <v-card 
            flat 
            style="border: 1px solid #E0E0E0;">
            <v-card-text>
              <v-row>
                <v-col 
                  cols="12" 
                  md="8" 
                  class="d-flex align-center">
                  <!-- ADD -->
                  <div class="mr-3">
                    <v-btn
                      elevation="0"
                      style="background: #00acc133;"
                      class="body-2 text-capitalize font-weight-bold d-flex align-center cyan--text text-darken-1"
                      @click="dialog.form = true; detail = {};">
                      <v-icon size="18">mdi-plus-circle-outline</v-icon>

                      <span class="ml-1">
                        Tambah
                      </span>
                    </v-btn>
                  </div>

                  <!-- EDIT -->
                  <div class="mr-3" v-if="selected.row.length === 1">
                    <v-btn
                      elevation="0"
                      style="background: #2196f333;"
                      class="body-2 text-capitalize font-weight-bold d-flex align-center blue--text"
                      @click="dialog.form = true; detail = selected.row[0]; reset(selected.row[0]);">
                      <v-icon size="18">mdi-circle-edit-outline</v-icon>

                      <span class="ml-1">
                        Ubah
                      </span>
                    </v-btn>
                  </div>

                  <!-- DELETE -->
                  <div class="mr-3" v-if="selected.row.length > 0">
                    <v-btn
                      elevation="0"
                      style="background: #f4403433;"
                      class="body-2 text-capitalize font-weight-bold d-flex align-center red--text"
                      @click="toDelete()">
                      <v-icon size="18">mdi-delete-circle-outline</v-icon>

                      <span class="ml-1">
                        Hapus
                      </span>
                    </v-btn>
                  </div>
                </v-col>

                <v-col 
                  cols="12" 
                  md="4" 
                  class="d-flex align-center justify-end">
                  <v-text-field 
                    class="mr-3"
                    dense
                    single-line
                    hide-details
                    color="#B71C1C"
                    placeholder="Cari . . ."
                    append-icon="mdi-magnify"
                    clearable
                    v-model="search"
                    vvvv-uppercase
                    @click:clear="search = ''; fetch();"
                    v-on:keyup.enter="fetch()">
                  </v-text-field>
                </v-col>
              </v-row>
            </v-card-text>

            <v-data-table
              v-model="selected.row"
              ref="table-grid"
              class="table-grid"
              :height="`calc(100vh - ${pagination.total_data > 0 ? '330px' : '258px'})`"
              :show-select="true"
              :single-select="false"
              :loading="process.load"
              loading-text="Sedang memuat data . . ."
              loader-height="5"
              no-results-text="Belum ada data"
              :options.sync="options"
              :headers="headers"
              :items="list.data"
              :items-per-page="100"
              item-key="id"
              @click:row="rowClick"
              @toggle-select-all="handleToggleAll($event)"
              hide-default-footer>
              <template
                v-for="header in configHeaders.filter((header) => header.hasOwnProperty('format'))"
                v-slot:[`item.${header.value}`]="{ value }">
                {{ rowFormat(header.format, value) }} 
              </template>

              <template v-slot:[`item.index`]="{ index }">
                {{ lastIndex + index }}
              </template>

              <v-progress-linear 
                v-show="process.load" 
                slot="progress" 
                color="white" 
                indeterminate>
              </v-progress-linear>
            </v-data-table>

            <pagination v-if="pagination.total_data > 0"
              @changePage="fetch($event)" 
              @reloadPage="fetch($event)" 
              :model="pagination"/>
          </v-card>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        show: false,
        dialog: {
          snackbar: false,
          fullscreen: false,
          form: false,
          delete: false,
          map: false
        },
        search: '',
        selected: {
          row: [],
          delete: []
        },
        options: {},
        headers: [],
        detail: {},
        list: {
          data: []
        },
        limit: 20,
        pagination: {},
        lastIndex: 0,
        upload: {
          folder: null
        },
        center: {
          lat: null,
          lng: null
        },
        time: {
          open: false,
          close: false
        },
        form: {
          id: '',
          content: '',
          image: '',
          extra: {
            lat: '',
            lng: ''
          },
          address: '',
          tipe_darah: '',
          produk: '',
          stok: '',
          status: 'draft'
        },
        process: {
          load: false,
          form: false,
          image: false,
          delete: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      uploadfolder: () => import(/* webpackPrefetch: true */ '@/components/upload/folder.vue'),
      pagination: () => import(/* webpackPrefetch: true */ '@/components/pagination.vue')
    },
    watch: {
      'options': {
        handler () {
          let pagination = { row: this.limit, page: 1 }
          this.fetch(pagination)
        },
        deep: true
      },
      'upload.folder': {
        handler: function () {
          if (this.upload.folder) {
            this.process.image = this.upload.folder.process

            if (!this.process.image) {
              // CALLBACK FROM UPLOAD IMAGE
              this.form.image = this.upload.folder.data.full.file_url
            }
          }
        },
        deep: true
      },
    },
    computed: {
      user () {
        return this.$store.state.user
      },
      configHeaders () {
        return this.headers.filter(header => !header.hide)  
      }
    },
    mounted () {
      this.fetch()
    },
    methods: {
      rowFormat (format, value) {
        let data = value

        if (format === 'number') {
          if (isNaN(value)) return 'Not a Number'
          let price = ''

          const reverseNumber = value
            .toString()
            .split('')
            .reverse()
            .join('')
          const arrReverseNumber = [...Array(reverseNumber.length).keys()]

          arrReverseNumber.map(index => {
            if (index % 3 === 0) price += reverseNumber.substr(index, 3) + '.'
          })

          return `${
            price.split('', price.length - 1)
            .reverse()
            .join('')
          }`
        } else if (format === 'array') {
          let arr = []

          for (let i = 0; i < value.length; i++) {
            arr.push(value[i].title)
          }

          data = arr.join(', ')
        } else if (format === 'datetime') {
          data = value.length > 0 ? moment(value).format(format === 'date' ? 'D MMM, YYYY' : format === 'time' ? 'HH:mm' : 'D MMM, YYYY HH:mm') : '-'
        } else if (format === 'object') {
          data = value.createdby.name
        } else if (format === 'regex') {
          let regex = /(<([^>]+)>)/ig

          data = value.replace(regex, '')
        } else if (format === 'on_off') {
          data = value ? 'Online' : 'Offline'
        } else if (format === 'g_m') {
          data = value ? 'Mandiri' : 'Group'
        } else if (format === 'v_a') {
          data = value ? 'Sudah Verifikasi' : 'Belum Verifikasi'
        } else {
          data = value ? 'Aktif' : 'Tidak Aktif'
        }
        return data
      },
      rowClick (item, row) {
        row.select(!row.isSelected ? true : false)
      },
      handleToggleAll (event) {
        if (!event.value) this.selected.row = []
      },
      async fetch (pagination = { row: 20, page: 1 }) {
        this.process.load = true

        this.limit = pagination.row

        let params = {
          limit: pagination.row,
          page: pagination.page,
          sort: this.options.sortBy.length < 1 ? 'id' : this.options.sortBy[0],
          order_by: this.options.sortDesc[0] ? 'ASC' : 'DESC',
          search: this.search
        }

        this.selected.row = []

        await get('data/darah', { params })
        .then(response => {
          let res = response.data

          this.process.load = false
            
          if (res.code === 200) {
            this.headers = [
              {
                text: '#No',
                width: '75px',
                value: 'index',
                sortable: false,
                freeze: true,
                hide: false,
                align: 'center'
              },
              {
                text: 'Golongan Darah',
                width: '200px',
                value: 'title',
                freeze: false,
                hide: false
              },
              {
                text: 'Tipe Darah',
                width: '150px',
                value: 'tipe_darah',
                freeze: false,
                hide: false
              },
              {
                text: 'Produk',
                width: '150px',
                value: 'produk',
                freeze: false,
                hide: false
              },
              {
                text: 'Stok',
                width: '100px',
                value: 'stok',
                freeze: false,
                hide: false
              },
              {
                text: 'Alamat',
                width: '400px',
                value: 'address',
                freeze: false,
                hide: false
              },
              {
                text: 'Status',
                width: '200px',
                value: 'status',
                freeze: false,
                hide: false
              }
            ]
            
            this.list.data = res.data
            this.pagination = res.pagination

            this.lastIndex = (pagination.page - 1) * pagination.row 
            this.lastIndex += 1

            this.getGeoLocation()
          }
        })
      },
      reset (item) {
        if (this.$refs.form) this.$refs.form.reset()
        
        this.form = {
          id: item !== undefined ? item.id : '',
          content: item !== undefined ? item.content : '',
          image: item !== undefined ? item.image : '',
          extra: item !== undefined ? item.extra : {
            lat: '',
            lng: ''
          },
          address: item !== undefined ? item.address : '',
          tipe_darah: item !== undefined ? item.tipe_darah : '',
          produk: item !== undefined ? item.produk : '',
          stok: item !== undefined ? item.stok : '',
          status: item !== undefined ? item.status : 'draft'
        }

        if (item !== undefined) {
          if (this.form.extra.time === undefined) {
            this.form.extra = {
              lat: this.form.extra.lat,
              lng: this.form.extra.lng
            }
          } else {
            this.form.extra = item.extra
          }
        }

        this.process.form = false

        this.message.error = ''
      },
      getGeoLocation() {
         this.$gmapApiPromiseLazy().then(() => {
          navigator.geolocation.getCurrentPosition(position => {
            this.center = {
              lat: position.coords.latitude,
              lng: position.coords.longitude
            }
          })
        })
      },
      setPlace(place) {
        this.center = {
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng()
        }

        this.form.extra.lat = place.geometry.location.lat()
        this.form.extra.lng = place.geometry.location.lng()

        this.form.address = place.formatted_address
      },
      updatePlace(location) {
        this.center = {
          lat: location.latLng.lat(),
          lng: location.latLng.lng()
        }

        this.form.extra.lat = location.latLng.lat()
        this.form.extra.lng = location.latLng.lng()

        const geocoder = new google.maps.Geocoder()
        geocoder.geocode({ latLng: this.center }, (result, status) => {
          if (status === google.maps.GeocoderStatus.OK) {
            this.form.address = result[0].formatted_address
          }
        })
      },
      toDelete () {
        this.selected.delete = []

        for (let i in this.selected.row) {
          this.selected.delete.push(parseInt(this.selected.row[i].id))
        }

        this.dialog.delete = true
      },
      async deletes () {
        this.message.error = ''

        this.process.delete = true

        await post(`data/darah/delete`, {
          data: {
            ids: this.selected.delete
          }
        }).then(response => {
          let res = response.data

          if (res.code === 200) {
            this.process.delete = false
            this.dialog.delete = false

            this.selected.row = []
            this.selected.delete = []
            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetch()
          } else {
            this.process.delete = false
            this.message.error = res.message
          }
        })
      },
      async save () {
        this.message.error = ''
        const isValid = await this.$refs.form.validate()

        if (isValid) {
          this.process.form = true

          let url = this.form.id === '' ? 'data/darah/create' : 'data/darah/update'
          
          // SAVE TO REST API
          await post(url, {
            data: this.form
          })
          .then(response => {
            let res = response.data

            this.process.form = false

            if (res.code === 200) {
              this.dialog.form = false

              this.dialog.reset = false

              this.dialog.snackbar = true

              this.message.success = res.message

              this.fetch()
            } else {
              this.message.error = res.message
            }
          })
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      }
    }
  }
</script>

<style scoped>
  ._maps {
    width: 100%;
    height: 500px;
  }
</style>